import { FC } from "react";
import { Button, Modal, message } from "antd";
import { ExclamationCircleFilled } from "@ant-design/icons";
import { RankingProjectService } from "modules/organization/services/rankingProject.service";
import { useRankingProjectListStore } from "modules/organization/store/rankingProjectListStore";

const DELETE_RANKING_PROJECT_TOAST_KEY = "deleteRankingProjectKey";

const DeleteRankingProject: FC<{
  open: boolean;
  projectSlug?: string;
  rankingProjectId: number | null;
  rankingProjectTitle: string;
  onClose: () => void;
}> = ({
  open,
  projectSlug,
  rankingProjectId,
  rankingProjectTitle,
  onClose,
}) => {
  const refreshRankingProjectList = useRankingProjectListStore(
    (state) => state.refreshRankingProjectList,
  );

  const doDeleteRankingProject = async () => {
    if (!projectSlug || !rankingProjectId) {
      return;
    }
    onClose();
    message.open({
      key: DELETE_RANKING_PROJECT_TOAST_KEY,
      content: "Deleting ranking project...",
      type: "loading",
      duration: 0,
    });
    try {
      await new RankingProjectService().deleteRankingProject(
        projectSlug,
        rankingProjectId,
      );
      await refreshRankingProjectList(projectSlug);
      message.success("Ranking project deleted successfully.");
    } catch (error: any) {
      const backendMessage = error?.error?.response?.data?.message;
      const contentMessage =
        !backendMessage && error instanceof Error ? error.message : null;
      message.error(
        backendMessage || contentMessage || "Failed to delete ranking project.",
      );
    } finally {
      message.destroy(DELETE_RANKING_PROJECT_TOAST_KEY);
    }
  };

  return (
    <Modal
      className="confirmationModal"
      title={<>Delete Ranking Project</>}
      centered
      open={open}
      destroyOnClose
      onCancel={onClose}
      footer={[
        <Button key="cancel" onClick={onClose}>
          Cancel
        </Button>,
        <Button
          key="delete"
          type="primary"
          onClick={() => {
            doDeleteRankingProject().catch(console.error);
          }}
        >
          Delete
        </Button>,
      ]}
    >
      <div className="notificationTxtWrap">
        <ExclamationCircleFilled
          className="mediumColor notificationIcon"
          aria-hidden
          aria-label=""
        />
        <div className="notificationTxt">
          <p>
            Are you sure you want to delete{" "}
            <strong>{rankingProjectTitle}</strong>?
          </p>
        </div>
      </div>
    </Modal>
  );
};

export default DeleteRankingProject;
